import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ClosePage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const redirectUrl = window.sessionStorage.getItem('redirectUrl');
    if (redirectUrl) {
      window.location.href = redirectUrl;
    } else {
      navigate('/error');
    }
  }, []);

  return <></>;
};

export default ClosePage;
